<form autocomplete="off" [formGroup]="innerForm">
    <div class="float-left smart-tag-form-container container" *ngIf="smartTagModel !== null">
        <div class="row" *ngIf="schemaShouldShowComplexForm">
            <div class="col-md-10 form-group-container" *ngFor="let formControl of formControl;">
                <div *ngIf="formControl.control === smartTagFormControlType.MULTIPLE"
                     formGroupName="{{formControl.field}}">
                    <label class="custom-control-label label-title">{{formControl.title}}</label>
                    <div class="custom-control custom-checkbox" *ngFor="let item of innerForm.get(formControl.field)['controls']; let index=index">
                        <label class="custom-control-label">
                            <input [formControlName]="index"
                                   type="checkbox"
                                   class="custom-control-input form-check-input">{{formControl.options[index].label}}
                        </label>
                    </div>
                </div>

                <div *ngIf="formControl.control === smartTagFormControlType.SINGLE">
                    <label class="custom-control-label label-title">{{formControl.title}}</label>
                    <cv-dropdown
                            [placeholder]="formControl.title"
                            [optionText]="'label'"
                            [selectedValue]="dropdownInitialValues[formControl.field]"
                            [options]="formControl.options"
                            (valuesChange)="onDropdownValueChange(formControl.field, $event)">
                    </cv-dropdown>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-10">
                <label>Description:</label>
                <textarea name="description"
                          formControlName="description"
                          (keyup)="smartTagModel.description = $event.currentTarget['value'];"
                          id="report-image-description" name="report-image-description" rows="3"
                          cols="50" [maxLength]="150"></textarea>
            </div>
        </div>
    </div>
</form>
